/* eslint-disable no-console */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
// import Backend from "i18next-http-backend";
import { Chinese, English, Spanish, French, German } from '../winflowsText';

const languages = [
  ['en', English],
  ['zh', Chinese],
  ['es', Spanish],
  ['fr', French],
  ['de', German],
];

const buildTranslations = (langPack) => ({
  translation: {
    ...langPack.Feed,
    ...langPack.EDI,
    ...langPack.RO,
    ...langPack.Header,
    ...langPack.Landing,
    ...langPack.Pump,
    ...langPack.ProjectInfo,
    ...langPack.Stripper,
    ...langPack.MixSplit,
    ...langPack.ChemDose,
    ...langPack.Cartridge,
    ...langPack.ERD,
    ...langPack.PW,
    ...langPack.TC,
    ...langPack.CIP,
    ...langPack.Help_Modal_Form,
    ...langPack.Notification_Modal,
    ...langPack.Preface,
    ...langPack.Flowsheet_Design_Summary,
    ...langPack.Feed_Product_Waste_Summary,
    ...langPack.RO_NF_Unit_System_Level_Summary,
    ...langPack.RO_NF_Unit_Stage_Level_Summary,
    ...langPack.DSSRO_Section_Summary,
    ...langPack.Pump_Summary,
    ...langPack.Detailed_Stream_Data,
    ...langPack.EDI_Unit_System_Level_Summary,
    ...langPack.CF_Unit_Summary,
    ...langPack.Chemical_Dosing_Unit_Summary,
    ...langPack.Antiscalant_Dosage_Summary,
    ...langPack.Mixer_Splitter_Unit_Summary,
    ...langPack.ERD_Unit_Summary,
    ...langPack.Detailed_RO_NF_Element_Level_Data,
    ...langPack.Winflows_Design_Simulator_Program_Details,
    ...langPack.Stripper_Unit_Summary,
  }
});

const resources = Object.fromEntries(
  languages.map(([key, value]) => [key, buildTranslations(value)])
);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  // .use(Backend)
  .init({
    debug: false,
    fallbackLng: 'en',
    resources
  });

export default i18n;
